import { Component, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import {
  CustomModalConfig,
  NgbCustomModalComponent,
} from 'components/modal-windows/ngb-custom-modal/ngb-custom-modal.component';
import { CustomFields } from '../../custom-fields.interface';
import { Observable, Subject } from 'rxjs';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { required } from '@certemy/common';
import { DEFAULT_MODAL_OPTIONS } from 'constants/constants';

@Component({
  selector: 'cm-custom-group-modal',
  templateUrl: './template-group-modal.component.html',
  styleUrls: ['./template-group-modal.component.scss'],
})
export class TemplateGroupModalComponent {
  @ViewChild('customGroupTemplate') customGroupTemplate;

  form: UntypedFormGroup;
  showError = false;

  private onClose = new Subject<CustomFields.Group | null>();

  constructor(private modalService: NgbModal, private fb: UntypedFormBuilder) {}

  close() {
    this.onClose.next(null);
  }

  save() {
    if (this.form.valid) {
      this.onClose.next(this.form.value);
    } else {
      this.showError = true;
    }
  }

  open(group: CustomFields.Group | null = { group_id: null, name: '' }): Observable<CustomFields.Group | null> {
    this.initForm(group);
    return Observable.create((observer) => {
      const modalRef = this.openModal(!!group.group_id);
      const onCloseSub = this.onClose.subscribe(observer);
      return () => {
        modalRef.close();
        onCloseSub.unsubscribe();
      };
    });
  }

  private initForm({ group_id, name }: CustomFields.Group) {
    this.showError = false;
    this.form = this.fb.group({
      name: this.fb.control(name, [required]),
      group_id,
    });
  }

  private openModal(isEditGroup: boolean) {
    const modalConfig: CustomModalConfig = {
      title: isEditGroup ? 'Edit group' : 'Add group',
      isCloseCrossVisible: false,
      hasCustomFooter: true,
      type: 'organization',
      hideHeader: false,
    };
    const modalRef = this.modalService.open(NgbCustomModalComponent, {
      ...DEFAULT_MODAL_OPTIONS,
      windowClass: 'sm',
    });
    modalRef.componentInstance.template = this.customGroupTemplate;
    modalRef.componentInstance.config = modalConfig;
    return modalRef;
  }
}
